import React from "react";
import BannerImage from "../Assets/home-carren.jpg";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

/* ─── Google Font Import ──────────────────────────────────────────────────── */
// Add this once in your index.html <head> (or global CSS):
// <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet">

const fontFamily = "'Plus Jakarta Sans', sans-serif";

const Home = () => {
  return (
    <div className="home-container" style={{
      background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
      position: "relative",
      overflow: "hidden",
      minHeight: "100vh",
    }}>
      <style>{`
        .home-container::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(37, 211, 102, 0.08) 0%, transparent 70%);
          border-radius: 50%;
        }

        @media (max-width: 768px) {
          .home-text-section h1 span {
            display: inline !important;
          }
          .home-text-section h1 span:first-child::after {
            content: ' ';
          }
          .home-text-section p {
            padding-left: 1.5rem;
          }
        }
      `}</style>
      <Navbar />

      <div className="home-banner-container" style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "4.5rem 1.5rem",
        position: "relative",
        zIndex: 1,
      }}>
        {/* Text Section */}
        <div className="home-text-section">
          {/* Main Heading */}
          <h1 style={{
            margin: 0,
            lineHeight: 1.15,
            fontSize: "clamp(2.4rem, 5.2vw, 3.7rem)",
            fontWeight: 900,
          }}>
            {/* Line 1 — thin, dark, smaller */}
            <span
              style={{
                display: "block",
                fontWeight: 520,
                fontSize: "clamp(2.1rem, 3.6vw, 3rem)",
                color: "#161C24",
                letterSpacing: "-0.015em",
              }}
            >
              Enabling
            </span>

            {/* Line 2 — heavy, with gradient for 'smarter' */}
            <span
              style={{
                display: "block",
                fontWeight: 600,
                fontSize: "clamp(2.3rem, 4.4vw, 3.5rem)",
                letterSpacing: "-0.03em",
                marginTop: "2px",
                color: "#007867",
              }}
            >
              <span
                style={{
                  background: "linear-gradient(135deg, #128C7E 0%, #25D366 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Smarter
              </span>{" "}
              Lending.
            </span>
          </h1>

          {/* Sub-copy */}
          <p
            style={{
              fontSize: "clamp(1.05rem, 2.5vw, 1.2rem)",
              lineHeight: 1.8,
              color: "#4a5568",
              marginTop: "18px",
              marginBottom: 0,
              maxWidth: "50ch",
            }}
          >
            Lume Solutions helps Lenders Digitize and Scale through
            Smart, Data-Driven Credit Tools.
          </p>

          {/* CTA Buttons */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "14px",
              marginTop: "32px",
            }}
          >
            {/* Primary — Book A Demo */}
            <Button
              component={Link}
              to="/book-now"
              variant="contained"
              disableElevation
              endIcon={<FiArrowRight strokeWidth={2.4} />}
              style={{
                fontWeight: 700,
                fontSize: "1rem",
                letterSpacing: "0.01em",
                textTransform: "none",
                backgroundColor: "#118D57",
                color: "#ffffff",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "32px",
                paddingRight: "32px",
                borderRadius: "10px",
                boxShadow: "0 4px 18px rgba(17,141,87,0.28)",
                transition: "background-color 0.18s, box-shadow 0.18s, transform 0.12s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#0d7046";
                e.currentTarget.style.boxShadow =
                  "0 6px 24px rgba(17,141,87,0.38)";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#118D57";
                e.currentTarget.style.boxShadow =
                  "0 4px 18px rgba(17,141,87,0.28)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Book A Demo
            </Button>
          </div>
        </div>

        {/* Image Section — untouched */}
        <div className="home-image-section">
          <img
            src={BannerImage}
            alt="Banner"
            style={{ width: "700px", height: "auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
